<h2 mat-dialog-title>Inserisci Area da GeoJson</h2>
<hr>
<form [formGroup]="newAreaForm" (ngSubmit)="onSubmit()">
    <mat-dialog-content id="new-area-container">
        <div class="field-container">
            <mat-form-field appearance="fill">
                <mat-label>Nome*</mat-label>
                <input matInput type="text" formControlName="areaName">
            </mat-form-field>
        </div>
        <div class="field-container">
            <mat-form-field appearance="fill">
                <mat-label>GeoJSON*</mat-label>
                <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="7"
                    cdkAutosizeMaxRows="7" formControlName="geoArea"></textarea>
            </mat-form-field>
        </div>
        <div *ngIf="newAreaForm.errors?.invalidGeoJson && (newAreaForm.touched || newAreaForm.dirty)" class="cross-validation-error-message alert alert-danger">
            Invalid GeoJson.
        </div>
    </mat-dialog-content>
    <hr>
    <mat-dialog-actions id="action-div">
        <button mat-stroked-button (click)="closeCancelling()" type="button">Annulla</button>
        <button mat-stroked-button color="primary" type="submit" [disabled]="!newAreaForm.valid">Inserisci</button>
    </mat-dialog-actions>
</form>